import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { CadViewerComponent } from "@components/cadViewer/cadViewer";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "cad-viewer-page",
	styleUrls: ["cadViewer.css"],
	templateUrl: "cadViewer.html"
})
export class CadViewerPageAdminComponent implements AfterViewInit {
	@ViewChild(CadViewerComponent) cadViewer!: CadViewerComponent;

	comparePickerVisible = false;
	fileName = "";
	hasFile = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	pickerVisible = false;
	title = "CAD Viewer";

	constructor(private toastService: ToastService) {
		this.headerPrimaryButtons = [{ icon: "fal fa-folder-open", method: "openPicker", text: "Open File" }];
	}

	clear() {
		this.fileName = "";
		this.hasFile = false;
		if (this.cadViewer) this.cadViewer.visible = false;
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	ngAfterViewInit() {
		// Open the picker on first load.
		setTimeout(() => { this.pickerVisible = true; }, 0);
	}

	onCompareFileSelected(e: any) {
		const file: File | undefined = e?.value?.[0];
		if (!file) return;
		const lower = (file.name || "").toLowerCase();
		if (lower.endsWith(".stp") === false && lower.endsWith(".step") === false) {
			this.toastService.error("Please choose a .stp or .step file.");
			return;
		}
		const reader = new FileReader();
		reader.onload = () => {
			this.cadViewer.loadCompareBuffer(reader.result as ArrayBuffer);
			this.comparePickerVisible = false;
		};
		reader.onerror = () => { this.toastService.error("Could not read file."); };
		reader.readAsArrayBuffer(file);
	}

	onCompareRequested() {
		if (!this.hasFile) {
			this.toastService.error("Load a CAD file first, then click Compare again.");
			return;
		}
		this.comparePickerVisible = true;
	}

	onFileSelected(e: any) {
		const file: File | undefined = e?.value?.[0];
		if (!file) return;
		const lower = (file.name || "").toLowerCase();
		if (lower.endsWith(".stp") === false && lower.endsWith(".step") === false) {
			this.toastService.error("Please choose a .stp or .step file.");
			return;
		}
		const reader = new FileReader();
		reader.onload = () => {
			this.fileName = file.name;
			this.hasFile = true;
			this.cadViewer.screenshotName = file.name.replace(/\.(stp|step)$/i, "") + "-3d";
			this.cadViewer.loadBuffer(reader.result as ArrayBuffer);
			this.pickerVisible = false;
		};
		reader.onerror = () => { this.toastService.error("Could not read file."); };
		reader.readAsArrayBuffer(file);
	}

	openPicker() {
		this.pickerVisible = true;
	}
}
